import { Geometry } from 'ol/geom';
import Feature from 'ol/Feature';
import GeoJSON from 'ol/format/GeoJSON';

import { fromCircle as PolygonFromCircle } from 'ol/geom/Polygon';
import GeoJsonHelper from 'client/utils/helpers/GeoJson/GeoJson';
import { CIRCLE } from 'client/utils/constants/geometryType';

export const geometry = {
    // Line length validation: for LineString/MultiLineString, checks both bounding box extent
    // AND actual line length (getLength) against the limit. This prevents zigzag lines from
    // exceeding the permitted length while staying within a smaller bounding box.
    isGreaterThan (geometry, limit) {
        if (!geometry) {
            return new Error('Geometry is required.');
        }
        if (geometry && !(geometry instanceof Geometry)) {
            return new Error('Geometry must be an instance of ol/geom');
        }
        if (limit === undefined || isNaN(limit)) {
            return new Error('Limit not found, or not a number');
        }
        const extent = geometry.getExtent();
        const width = extent[2] - extent[0];
        const height = extent[3] - extent[1];
        const exceedsExtent = width > limit || height > limit;
        const geomType = geometry.getType?.();
        if (geomType === 'LineString' || geomType === 'MultiLineString') {
            return exceedsExtent || geometry.getLength() > limit;
        }
        return exceedsExtent;
    }
};

export const feature = {
    isValid (feature) {
        if (feature && feature instanceof Feature) {
            let checkFeature = feature;
            const geometry = feature.getGeometry();
            let geoJson = null;
            const writer = new GeoJSON();

            if (geometry.getType() === CIRCLE) {
                checkFeature = new Feature({
                    geometry: PolygonFromCircle(geometry)
                });
            }

            geoJson = writer.writeFeatureObject(checkFeature);
            return GeoJsonHelper.feature.isValid(geoJson);
        } else {
            return new Error('isValid: invalid feature type');
        }
    },
    isSimple (feature) {
        if (feature && feature instanceof Feature) {
            let checkFeature = feature;
            const geometry = feature.getGeometry();
            let geoJson = null;

            const writer = new GeoJSON();

            if (geometry.getType() === CIRCLE) {
                checkFeature = new Feature({
                    geometry: PolygonFromCircle(geometry)
                });
            }

            geoJson = writer.writeFeatureObject(checkFeature);
            return GeoJsonHelper.feature.isSimple(geoJson);
        } else {
            return new Error('isSimple: invalid feature type');
        }
    }
};

export default { geometry, feature };
